import { ListingTag } from '../_types/listing-tag'
import { LegacyListingDecisions } from '../_types/legacy-listing-decisions'

const LEGACY_TAGS_STORAGE_KEY_PREFIX = 'quickpass:listing-tags:'
const LEGACY_NOTES_STORAGE_KEY_PREFIX = 'quickpass:listing-notes:'

/**
 * Reads any legacy device-local tags + notes that pre-date the move to
 * profile-based storage. Used once on first profile load to fold them
 * forward.
 *
 * @param {string} quickPassUserId - the user id the legacy keys were scoped to
 * @returns {LegacyListingDecisions} the legacy maps (empty when nothing stored)
 */
const readLegacyListingDecisions = (
  quickPassUserId: string,
): LegacyListingDecisions => {
  let tags: Record<string, ListingTag> = {}
  let notes: Record<string, string> = {}

  try {
    const raw = window.localStorage.getItem(
      `${LEGACY_TAGS_STORAGE_KEY_PREFIX}${quickPassUserId}`,
    )
    if (raw !== null) {
      tags = JSON.parse(raw) as Record<string, ListingTag>
    }
  } catch (error) {
    console.warn('[listing-decisions] failed to read legacy tags', error)
  }

  try {
    const raw = window.localStorage.getItem(
      `${LEGACY_NOTES_STORAGE_KEY_PREFIX}${quickPassUserId}`,
    )
    if (raw !== null) {
      notes = JSON.parse(raw) as Record<string, string>
    }
  } catch (error) {
    console.warn('[listing-decisions] failed to read legacy notes', error)
  }

  return { tags, notes }
}

/**
 * Removes the legacy device-local tag + note entries once they have
 * been folded into the profile.
 *
 * @param {string} quickPassUserId - the user id the legacy keys were scoped to
 * @returns {void}
 */
const clearLegacyListingDecisions = (quickPassUserId: string): void => {
  try {
    window.localStorage.removeItem(
      `${LEGACY_TAGS_STORAGE_KEY_PREFIX}${quickPassUserId}`,
    )
    window.localStorage.removeItem(
      `${LEGACY_NOTES_STORAGE_KEY_PREFIX}${quickPassUserId}`,
    )
  } catch (error) {
    console.warn('[listing-decisions] failed to clear legacy entries', error)
  }
}

export { readLegacyListingDecisions, clearLegacyListingDecisions }
